import MarkdownIt from 'markdown-it';
const md = new MarkdownIt();
export function renderSeoMarkdown(raw) {
    return md.render(raw).replace(/<\/?h1(\s|>)/g, (m) => m.replace('h1', 'h2'));
}
function urlWithOptionalCacheBust(url, cacheBust) {
    if (!cacheBust)
        return url;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}t=${Date.now()}`;
}
export function applyStaticSeoPlaceholders(raw, brandTitle) {
    return raw
        .replace(/%(domain|brand)%/g, brandTitle)
        .replace(/%year%/g, new Date().getFullYear().toString());
}
export async function fetchLocaleRawWithEnFallback(localeUrl, enUrl, options) {
    const bust = options?.cacheBust === true;
    async function attempt(url) {
        const res = await fetch(urlWithOptionalCacheBust(url, bust));
        if (!res.ok)
            throw new Error(`${res.status}`);
        const lm = res.headers.get('Last-Modified');
        let lastModified = '';
        if (lm) {
            const d = new Date(lm);
            if (!isNaN(d.getTime()))
                lastModified = d.toISOString().split('T')[0];
        }
        const raw = await res.text();
        return { raw, lastModified };
    }
    try {
        return await attempt(localeUrl);
    }
    catch {
        try {
            return await attempt(enUrl);
        }
        catch {
            return { raw: '', lastModified: '' };
        }
    }
}
export async function fetchLocaleMarkdownWithEnFallback(localeUrl, enUrl, options) {
    const { raw, lastModified } = await fetchLocaleRawWithEnFallback(localeUrl, enUrl, options);
    return { html: renderSeoMarkdown(raw), lastModified };
}
